import Image from "next/image";
import Link from "next/link";
import Head from "next/head";
import { ExitIntentMat } from "../components/ExitIntentMat/ExitIntentMat";
import styles from "./Layout.module.scss";
import cx from "classnames";
import { ShareContent } from "../components/ShareContent/ShareContent";
import { Comments } from "../components/Comments/Comments";
import { Footer } from "../components/Footer/Footer";

const variantToLogo = {
  primary: "/logo-white.png",
  white: "/logo.png",
};

const defaultMeta = {
  title: "Devs for Good",
  description: "Help others & grow as a dev",
};

export const ContentLayout = ({
  children,
  variant,
  textVariant = "large",
  meta,
}: {
  children: React.ReactNode;
  variant: "primary" | "white";
  textVariant?: "small" | "large";
  meta?: {
    url: string;
    title?: string;
    description?: string;
    image?: string;
    authors?: string[];
  };
}) => {
  const { title, description, image, authors, url } = {
    ...defaultMeta,
    ...meta,
  };

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const shareUrl = meta?.url || currentUrl || "https://devsforgood.com";

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={url} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@devsforgood" />
        <meta name="twitter:creator" content={authors?.join(", ")} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
      </Head>
      <div className={styles.container}>
        <nav
          className={cx(styles.nav, {
            [styles["nav--white"]]: variant === "white",
          })}
        >
          <div className={styles.navContainer}>
            <Link href="/">
              <Image
                src={variantToLogo[variant]}
                alt="Logo"
                width={300}
                height={120}
              />
            </Link>
            <Link href="/?from=nav-button" className={styles.navButton}>
              Help others & grow as a dev
            </Link>
          </div>
        </nav>
        <div
          className={cx(styles.main, {
            [styles[`main--small-font`]]: textVariant === "small",
          })}
        >
          {children}
          <ShareContent shareUrl={shareUrl} title={title} />
          <div className={styles.comments}>
            <Comments />
          </div>
        </div>
        <ExitIntentMat />
      </div>
      <Footer />
    </>
  );
};
